<template>
  <div class="d-flex flex-column justify-content-around align-items-center mb-3" :class="[typeof $store.getters.getNotificationBar.is_message !== 'undefined' && $store.getters.getNotificationBar.is_message === true && !$store.getters.getNotificationBarClosedIds.includes($store.getters.getNotificationBar.id) ? 'min-vh-20': '']">
    <!-- notification bar -->
    <div role="alert" class="d-flex w-100 mb-3 bg-blue pt-3 pb-3 pl-4 pr-4 position-absolute position-top-0 header-notification-z" v-if="($router.enableNotificationBarRoutes.includes($route.name) || $store.getters.getMeetingDisconnectedAs === 'agent' || $store.getters.getMeetingEndedAs === 'agent' || $store.getters.getUser !== false) && typeof $store.getters.getNotificationBar.is_message !== 'undefined' && $store.getters.getNotificationBar.is_message === true && !$store.getters.getNotificationBarClosedIds.includes($store.getters.getNotificationBar.id) && $root.isAppReconnecting === false">

      <p class="mr-3"><span v-html="sanitizedNotificationMessage"></span> <strong>| <a href="#" @click.prevent="closeNotificationBar($store.getters.getNotificationBar.id)">{{ $t('Header.Close message') }}</a></strong></p>

      <img v-if="$store.getters.getNotificationBar.message_type === 'informational'" class="d-flex ml-auto mt-auto mb-auto" src="../assets/info.svg" alt="Info">
      <img v-if="$store.getters.getNotificationBar.message_type === 'announcement'" class="d-flex ml-auto mt-auto mb-auto" src="../assets/announcement.svg" alt="Announcement">
      <img v-if="$store.getters.getNotificationBar.message_type === 'issue'" class="d-flex ml-auto mt-auto mb-auto" src="../assets/error.svg" alt="Issue">
    </div>

    <!-- reconnecting app -->
    <component :is="reconnectingComponent"></component>

    <!-- logo: 123meekijken only. Login uses header_logo (useHeaderWithoutPayoff); other pages use logo_payoff. -->
    <div class="d-flex justify-content-center align-items-center w-100" :class="logoWrapperClass" v-if="$store.getters.getProduct === 'direct' || $route.name !== 'meeting' || $store.getters.getUser !== false || $store.getters.getMeetingEndedAs === 'agent' || $store.getters.getMeetingDisconnectedAs === 'agent'">
      <img v-if="$store.getters.isMeekijken" :src="useHeaderWithoutPayoff ? headerLogo : logoPayoff" class="meekijken_logo meekijken-logo-header" alt="123meekijken logo" />
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { sanitizeRichHtml } from '../utils/sanitize'
import headerLogo from '../assets/meekijken/header_logo.png'
import logoPayoff from '../assets/meekijken/logo_payoff.png'

export default {
  name: 'MeekHeader',
  props: ['useHeaderWithoutPayoff'],
  data () {
    return {
      headerLogo,
      logoPayoff
    }
  },
  methods: {
    closeNotificationBar (id) {
      this.$store.commit('addNotificationBarClosedId', id)
    }
  },
  components: {
    reconnecting: defineAsyncComponent(() => import('./Reconnecting.vue'))
  },
  computed: {
    /** Login (useHeaderWithoutPayoff) keeps original compact header; other pages get padding. */
    logoWrapperClass () {
      return this.useHeaderWithoutPayoff ? '' : 'px-3 py-2'
    },
    reconnectingComponent () {
      return 'reconnecting'
    },
    sanitizedNotificationMessage () {
      const msg = this.$store.getters.getNotificationBar?.message
      return msg ? sanitizeRichHtml(msg) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.header-notification-z {
  z-index: 101 !important;
}

.meekijken-logo-header {
  max-width: 500px;
  width: 80%;
}
</style>
